export default (url, text = '') => {
  return new Promise((resolve, reject) => {
    const head = document.head;
    const scripts = Array.prototype.slice.call(document.scripts);
    let existingScript = null;

    for (const script of scripts) {
      if (script.src === url) existingScript = script;
    }

    if (existingScript) {
      resolve();
    } else {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      if (text !== '') script.textContent = text;

      script.addEventListener('load', resolve);
      script.addEventListener('error', reject);

      head.appendChild(script);
    }
  });
};
